<template>
  <div :class="className" :style="{height:height,width:width}"></div>
</template>
<script>
  import echarts from 'echarts'

  export default {
    props: {
      className: {
        type: String,
        default: 'lineChart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '368px'
      },
      chartData: {
        type: Object
      }
    },
    data () {
      return {
        chart: null
      }
    },
    mounted () {
      this.initChart()
    },
    beforeDestroy () {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    watch: {
      chartData: {
        deep: true,
        handler (val) {
          this.setOption(val)
        }
      }
    },
    methods: {
      setOption ({lineData, week} = {}) {
        this.chart.setOption({
          xAxis: {
            name: '时间轴',
            type: 'category',
            data: week,
            // axisTick: {
            //        alignWithLabel: true,

            //   },
          },
          yAxis: {
            name: '成交量（笔）',
            splitLine: {
              show: false,
            }
          },
          tooltip: {
            trigger: 'axis'
          },

          series: [
            {
              name: '成交量（笔）',
              type: 'line',
              areaStyle: {normal: {}},
              data: lineData
            }
          ]
        })
      },
      initChart () {
        this.chart = echarts.init(this.$el)
        this.setOption(this.chartData)
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/lineChart.vue